<template>
  <i :style="styleObject" :class="`ih i-ih_${icon} ${compiledColorClasses}`"></i>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    /**
     * functional color like "primary" with an additional space separated color modifier like "lighten-1" (1-4 allowed)
     * or "darken-1" (1-4 allowed)
     */
    iconColor: {
      type: String,
      default: '',
    },
    /**
     * CSS Color will preceed iconColor
     */
    color: {
      type: String,
    },
    fontSize: {
      type: String,
      default: '24px',
    },
  },
  data() {
    return {
      styleObject: {
        color: this.color ? this.color + ' !important' : null,
        fontSize: this.fontSize,
        paddingRight: '4px',
      },
    };
  },
  computed: {
    compiledColorClasses() {
      let compiledClass = this.iconColor
        .split(' ')
        .filter((clz) => clz !== '')
        .map((clz, ind) => {
          if (ind === 0 && clz.indexOf('#') < 0) {
            return `${clz}--text`; //e.g. primary--text
          }
          if (ind === 1) {
            return `text--${clz}`; //e.g. text--lighten-3
          }
        })
        .join(' ');
      return compiledClass;
    },
  },
};
</script>

<style></style>
